import { Trophy, Camera } from "lucide-react";

const fmt = (d) => new Date(d + "T12:00:00").toLocaleDateString("fr-FR", { day: "numeric", month: "short" });

export function TeamTrophies({ trophies }) {
  return (
    <section className="bg-white rounded-2xl border-2 border-slate-200 p-5 space-y-3 rise rise-2" data-testid="team-trophies">
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold uppercase tracking-widest text-slate-500">Trophées de l'équipe</span>
        <span className="font-display text-xl font-bold text-amber-600" data-testid="team-trophies-count">{trophies.length}</span>
      </div>
      {trophies.length === 0 ? (
        <p className="text-sm text-slate-600" data-testid="team-trophies-empty">Réussissez le défi de la semaine pour gagner votre premier trophée.</p>
      ) : (
        <div className="flex gap-3 overflow-x-auto pb-1">
          {trophies.map((t) => (
            <div key={`${t.kind}-${t.week_start}`} className="shrink-0 w-24 flex flex-col items-center text-center gap-1" data-testid={`team-trophy-${t.kind}-${t.week_start}`}>
              <span className={`w-16 h-16 rounded-full text-slate-900 grid place-items-center shadow-md border-4 ${t.kind === "photo" ? "bg-sky-400 border-sky-200" : "bg-amber-400 border-amber-200"}`}>
                {t.kind === "photo" ? <Camera className="w-8 h-8" /> : <Trophy className="w-8 h-8" />}
              </span>
              <span className="text-xs font-bold">Sem. du {fmt(t.week_start)}</span>
              <span className="text-[11px] text-slate-500">{t.done}/{t.target} {t.kind === "photo" ? "outils" : "leçons"}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
